<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper flexbox-center">
                <div class="modal-container">
                    <div v-if="topbar && topbar.length > 0" class="modal-topbar">
                        <div class="columns is-mobile">
                            <div v-for="item in topbar" :key="item.id" @click="setSelected(item)" class="column" :class="{'active': item.selected}">{{item.name}}</div>
                        </div>
                    </div>
                    <button type="button" @click="closeModal" class="close-button">
                        <span aria-hidden="true" tabindex="-1">×</span>
                    </button>
                    <div class="modal-body" v-show="!topbar || topbar && topbar.length > 0 && topbar[0].selected" :class="{'margin-60': topbar && topbar.length > 0}">
                        <slot name="body">
                            <component :is="selectedView" :userAction="userAction" @close="closeModal" :data="data"></component>
                        </slot>
                    </div>
                    <div class="map-body visibility" :class="[{'margin-60': topbar && topbar.length > 1}, {'visible': topbar && topbar.length > 1 && topbar[1].selected}]">
                        <map-component :modalComponent="true" :pos="data"></map-component>
                    </div>
                    <div class="image-body" v-show="topbar && topbar.length > 2 && topbar[2].selected" :class="{'margin-60': topbar && topbar.length > 2}">
                        <file-upload :modalComponent="true" :repeater="true" :userAction="userAction"></file-upload>
                    </div>
                    <div class="modal-bottombar">
                        <div class="buttons-modal text-center">
                            <a v-if="userAction === 'update'" @click="saveItem()">{{ $t('save')}}</a>
                            <a v-else @click="addItem()">{{ $t('add')}}</a>
                            <a @click="closeModal()">{{ $t('undo')}}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { mapActions } from "vuex";
import modalRepeater from "./../../formelements/modal/repeater-modal";
import mapComponent from "./../map/map.vue";
import fileUpload from "./../fileupload/fileupload.vue";

export default {
  name: "modal",
  data() {
    return {
      selectedView: null
    };
  },
  components: {
    "modal-repeater": modalRepeater,
    "map-component": mapComponent,
    "file-upload": fileUpload
  },
  props: ["modalType", "data", "topbar", "userAction"],
  methods: {
    ...mapActions({
      addRepeater: "addRepeater",
      updateRepeater: "updateRepeater"
    }),
    saveItem() {
      this.updateRepeater(this.data);
      console.log("update item", this.data);
      this.$emit("close");
    },
    addItem() {
      this.addRepeater(this.data);
      console.log("add item", this.data);
      this.$emit("close");
    },
    closeModal() {
      this.$emit("close");
    },
    setSelected(item) {
      this.$emit("setSelectedTopbar", item);
    }
  },
  created() {
    this.selectedView = this.modalType;
    console.log("data", this.data);
  }
};
</script>
